import Eyebrow from './Eyebrow'

export default function SectionHeader({ num, kicker, title, sub, align = 'left', maxW = 'max-w-3xl' }) {
  const wrap = align === 'center' ? `text-center mx-auto ${maxW}` : maxW
  return (
    <div className={wrap}>
      <Eyebrow num={num}>{kicker}</Eyebrow>
      <h2 className="font-display text-4xl sm:text-5xl md:text-6xl mt-5 leading-[1.02] text-[var(--ink)]">
        {title}
      </h2>
      {sub && <p className="mt-5 text-[var(--ink-3)] text-[17px] leading-relaxed max-w-2xl">{sub}</p>}
    </div>
  )
}
